export const ProjectsData =
    {
        para1: 5,
        para2:10,
        para3:20,
        para4:15
    }
  export const RequestsData =
    {
        para1: 25,
        para2:10,
        para3:20,
        para4:16
    }